import React from 'react';

import 'ui-kit/icons/social-media-icons/social-media-icon.style.css';

const Facebook = ({ variant }) => {
    const getVariantStyle = () => {
        switch (variant) {
            case 'light': {
                return { fill: 'rgb(255,255,255)', height: '22.368', width: '27.632' };
            }
            case 'primary': {
                return { fill: 'rgb(3,164,220)', height: '22.368', width: '27.632' };
            }
            default: {
                return { fill: 'rgb(3,164,220)', height: '100%', width: '100%' };
            }
        }
    };

    const variantStyle = getVariantStyle();

    return (
        <svg
            className="social-media-icon twitter"
            xmlns="http://www.w3.org/2000/svg"
            width={variantStyle.width}
            height={variantStyle.height}
            viewBox="0 0 27.632 22.368"
        >
            <path
                fill={variantStyle.fill}
                fillRule="evenodd"
                d="M27.63157895 2.65769279c-.78393074 1.14042051-1.73019057 2.11313213-2.84075912 2.91813484.01187774.16376281.0178166.4084205.0178166.73397307 0 1.51332618-.22171778 3.02467932-.66713297 4.53405941-.44343557 1.50740705-1.11848704 2.95562272-2.02515441 4.34267397-.90468775 1.38705125-1.98358233 2.61231273-3.2327245 3.6777575-1.25112178 1.06544477-2.75959457 1.9178006-4.52343873 2.55114832-1.76582379.63532077-3.65240458.95298115-5.66370163.95298115-3.16937655 0-6.06556512-.84446363-8.69648419-2.5333909.40978198.04538006.86509529.0690566 1.36791955.0690566 2.62893945 0 4.97281317-.80302966 7.02964155-2.41106205-1.2273663-.02367655-2.32605711-.40052831-3.29607242-1.12660919-.97001531-.73002697-1.63714829-1.65933158-1.99941931-2.78791382.3860265.05721833.74235865.08681402 1.07097608.08681402.50282426 0 .99970966-.06313747 1.49065618-.19138545-1.31051048-.26833424-2.3933643-.91746633-3.25252072-1.94936932C1.5520245 10.49463099 1.1224463 9.29699215 1.1224463 7.9355905v-.07102965c.79382885.44196227 1.6470464.68070082 2.55965264.71621565-.772053-.51299193-1.38573616-1.18382753-1.84104947-2.01053375-.4553133-.82670622-.68494958-1.72444209-.68494958-2.69123457 0-1.0240108.257351-1.97304587.772053-2.84710519 1.4154305 1.73628037 3.13572296 3.12530466 5.16483661 4.16707288 2.02713404 1.04176822 4.19878056 1.62184371 6.51295994 1.74022646-.09304229-.44393532-.14055324-.87405932-.14055324-1.29234504 0-1.56265233.55231484-2.89248525 1.65694452-3.9954179C16.22697038.55245284 17.56321596 0 19.12909782 0c1.63516866 0 3.01496595.5938868 4.13543261 1.78363347 1.27487727-.24465769 2.47254923-.70043129 3.59499552-1.3633747-.43155784 1.33969815-1.2610199 2.37554723-2.48838622 3.1095203 1.08681308-.11443667 2.17362615-.40644745 3.26043922-.87208628"
            />
        </svg>
    );
};

export default Facebook;
